/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function () {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // document.addEventListener('theme:variant:change', function(event) {
  //   // You might use something like this to write a pre-order feature or a
  //   // custom swatch feature.
  //   var variant = event.detail.variant;
  //   var container = event.target;
  //   if (variant) {
  //     console.log('Container ———————— ↓');
  //     console.log(container);
  //     console.log('Variant —————————— ↓');
  //     console.log(variant);
  //     // ... update some element on the page
  //   }
  // });
  //
  // document.addEventListener('theme:cart:change', function(event) {
  //   var cart = event.detail.cart;
  //   if (cart) {
  //     console.log('Cart ———————————— ↓');
  //     console.log(cart);
  //     // ... update an app or a custom shipping caluclator
  //   }
  // });
  // // Fired when page loads to update header values
  // document.addEventListener('theme:cart:init', (e) => {
  //   console.log('theme:cart:init');
  //   console.log(e);
  // });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener('theme:pagination:done', function (e) {
    const { sectionId } = e.detail;

    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return;
    const target = document.querySelector('.collection__heading') || section;
    const headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10,
    ) || 0;

    const rect = target.getBoundingClientRect();
    const scrollTop = window.pageYOffset + rect.top - headerHeight;

    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.product__color-swatch').forEach((swatch) => {
      const swatchItems = swatch.querySelectorAll('.product__color-swatch-item');
      const titleRoot = swatch.closest('.product__block__color-swatch') || swatch;
      const titleElement = titleRoot.querySelector('[data-color-swatch-title]');

      if (!swatchItems.length) {
        return;
      }

      const defaultTitle = titleElement ? titleElement.textContent : null;

      let selectedItem = swatch.querySelector('.product__color-swatch-item.active') || swatchItems[0];

      const setActive = (item) => {
        swatchItems.forEach((el) => el.classList.remove('active'));
        if (item) item.classList.add('active');
      };

      const setTitle = (item) => {
        if (!titleElement) return;
        const desc = item ? item.getAttribute('data-short-description') : null;
        titleElement.textContent = desc || defaultTitle || '';
      };

      setActive(selectedItem);

      swatchItems.forEach((item) => {
        item.addEventListener('mouseenter', function () {
          setActive(this);
          const newDescription = this.getAttribute('data-short-description');
          if (newDescription && titleElement) titleElement.textContent = newDescription;
        });

        item.addEventListener('mouseleave', function () {
          setActive(selectedItem);
          setTitle(selectedItem);
        });

        item.addEventListener('click', function (e) {
          selectedItem = this;
          setActive(selectedItem);
          setTitle(selectedItem);
        });
      });
    });

    const elem = document.querySelector('.product__inner');
    if (elem) {
      const pt = window.getComputedStyle(elem, null).getPropertyValue('padding-top');
      elem.style.top = `calc(-${pt} + var(--header-height, 56px))`;
    }

    const selectors = {
      verticalDropdown: '.header__dropdown.header__dropdown--vertical',
      imagesContainer: '.header__dropdown__right',
      linkItem: '.navlink.navlink--grandchild',
      defaultImage: '[data-connected-link="default"]',
    };

    const verticalDropdowns = document.querySelectorAll(selectors.verticalDropdown);

    const updateVerticalDropdownImage = (container, imageElem) => {
      if (!imageElem || imageElem.classList.contains('block')) return;

      const currentImage = container.querySelector('.block');

      currentImage.classList.add('hidden');
      currentImage.classList.remove('block');

      imageElem.classList.add('block');
      imageElem.classList.remove('hidden');
    };

    verticalDropdowns.forEach((dropdown) => {
      const imagesContainer = dropdown.querySelector(selectors.imagesContainer);

      if (imagesContainer) {
        const defaultImage = imagesContainer.querySelector(selectors.defaultImage);
        dropdown.querySelectorAll(selectors.linkItem).forEach((link) => {
          link.addEventListener('mouseenter', ({ target }) => {
            const connectedImage = imagesContainer.querySelector(
              `[data-connected-link="${target.getAttribute('href')}"]`
            );
            if (connectedImage) {
              updateVerticalDropdownImage(imagesContainer, connectedImage);
              return;
            }
            updateVerticalDropdownImage(imagesContainer, defaultImage);
          });
        });
      }
    });
  });


  const collectionDescription = document.querySelector('.collection__heading__description');
  if (!collectionDescription) return;

  const collectionDescriptionText = collectionDescription.querySelector('p');
  if (!collectionDescriptionText) return;

  const desktopLimit = collectionDescription.getAttribute('data-max-chars-desktop') || 200;
  const mobileLimit = collectionDescription.getAttribute('data-max-chars-mobile') || 200;

  const fullText = collectionDescriptionText.innerText.trim();
  const isMobile = window.innerWidth < 768;
  const limit = isMobile ? mobileLimit : desktopLimit;

  if (fullText.length <= limit) {
    collectionDescriptionText.innerText = fullText;
    return;
  }

  const shortText = fullText.slice(0, limit);
  collectionDescriptionText.innerHTML = `${shortText}... <button class="read-more-btn">${window.theme.strings.readMore}</button>`;

  const button = collectionDescriptionText.querySelector('.read-more-btn');
  let isExpanded = false;

  button.addEventListener('click', function () {
    isExpanded = !isExpanded;
    collectionDescriptionText.innerHTML = isExpanded
      ? `${fullText} <button class="read-more-btn active">${window.theme.strings.readLess}</button>`
      : `${shortText}... <button class="read-more-btn">${window.theme.strings.readMore}</button>`;

    collectionDescriptionText.querySelector('.read-more-btn').addEventListener('click', arguments.callee);
  });
})();
document.addEventListener('DOMContentLoaded', () => {
  const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent);
  if (!isIOS) return;

  const jiggleScroll = () => {
    const y = window.pageYOffset || document.documentElement.scrollTop || 0;
    window.scrollTo(0, y + 1);
    window.scrollTo(0, y);
  };

  const scheduleJiggle = (delay = 120) => {
    setTimeout(jiggleScroll, delay);
  };

  document.addEventListener('focusout', (event) => {
    const target = event.target;
    if (!target.matches('input, textarea, select')) return;

    const modal = target.closest('.micromodal-slide.is-open');
    if (!modal) return;

    scheduleJiggle(120);
  });

  document.addEventListener('click', (event) => {
    const closeEl = event.target.closest('[data-micromodal-close]');
    if (!closeEl) return;

    const modal = closeEl.closest('.micromodal-slide.is-open');
    if (!modal) return;

    scheduleJiggle(300);
  });

  document.addEventListener('micro:modal:close', (event) => {
    const { modal } = event.detail || {};

    if (modal && !modal.classList.contains('is-open')) {
      scheduleJiggle(300);
    } else {
      scheduleJiggle(300);
    }
  });
});
document.addEventListener('DOMContentLoaded', () => {
  let openModalsCount = 0;

  const body = document.body;

  const applyBodyBgForModal = () => {
    if (openModalsCount > 1) {
      return;
    }
    const currentBg = window.getComputedStyle(body).backgroundColor || '';
    body.dataset.modalOriginalBg = currentBg;
    body.style.backgroundColor = '#FFFFFF';
  };

  const restoreBodyBgAfterModal = () => {
    openModalsCount = Math.max(0, openModalsCount - 1);
    if (openModalsCount > 0) return;

    const original = body.dataset.modalOriginalBg;

    if (typeof original !== 'undefined') {
      if (!original || original === 'rgba(0, 0, 0, 0)') {
        body.style.removeProperty('background-color');
      } else {
        body.style.backgroundColor = original;
      }
      delete body.dataset.modalOriginalBg;
    } else {
      body.style.removeProperty('background-color');
    }
  };
  document.addEventListener('micro:modal:show', () => {
    openModalsCount += 1;
    applyBodyBgForModal();
  });
  document.addEventListener('micro:modal:close', () => {
    restoreBodyBgAfterModal();
  });
});

(function () {

  document.addEventListener('DOMContentLoaded', () => {

    /* ===== CONDITIONS ===== */
    const DESKTOP = () => window.innerWidth >= window.theme.sizes.medium;
    let desktopActive = false;

    /* ===== HEADER SECTION CHECK ===== */
    const headerSection = document.querySelector('[data-section-type="header"]');
    if (!headerSection) return;

    const isDrawerHeader = headerSection.getAttribute('data-header-style') === 'drawer';
    if (!isDrawerHeader) return;

    if (!headerSection.hasAttribute('data-accordion-single')) return;

    /* ===== MENU ROOT ===== */
    const menu = document.querySelector('.drawer__menu[data-sliderule-pane="0"]');
    if (!menu) return;

    /* ===== ACCORDIONS: TOP LEVEL ONLY ===== */
    const accordions = Array.from(menu.children).
      filter(el => el.classList.contains('listitem__wrapper')).
      map(el => el.querySelector('.listitem__accordion')).
      filter(Boolean);

    if (!accordions.length) return;

    const getHead = acc => acc.querySelector('[data-accordion-trigger]');
    const getBody = acc => acc.querySelector('[data-accordion-body]');

    /* ===== PREFERRED ACCORDION (active link parent or first) ===== */
    let preferredAccordion = null;

    /* ===== RADIO-MODE OPEN ===== */
    function openAccordion (accToOpen) {
      accordions.forEach(acc => {
        const head = getHead(acc);
        const body = getBody(acc);
        if (!head || !body) return;

        const isTarget = acc === accToOpen;

        if (isTarget) {
          head.classList.add('accordion-is-open');
          head.setAttribute('aria-expanded', 'true');
          body.dispatchEvent(new CustomEvent('theme:accordion:open', { bubbles: false }));
        } else {
          head.classList.remove('accordion-is-open');
          head.setAttribute('aria-expanded', 'false');
          body.dispatchEvent(new CustomEvent('theme:accordion:close', { bubbles: false }));
        }
      });
    }

    /* ===== FIRST (PREFERRED) ACCORDION MUST BE OPEN ON DESKTOP ===== */
    function ensureFirstOpen () {
      if (!DESKTOP()) return;

      const target = preferredAccordion || accordions[0];
      if (!target) return;

      const head = getHead(target);
      if (!head) return;

      if (!head.classList.contains('accordion-is-open')) {
        openAccordion(target);
      }
    }

    function openActiveLinkParents () {
      let acc;
      const activeLink = menu.querySelector('.listitem__title.listitem__title--active');
      if (activeLink) {
        acc = activeLink.closest('.listitem__accordion');
        preferredAccordion = acc;
      } else {
        acc = accordions[0];
      }

      if (!acc) return;

      const head = getHead(acc);
      const body = getBody(acc);
      if (!head || !body) return;

      if (DESKTOP()) {
        openAccordion(acc);
      } else {
        head.classList.add('accordion-is-open');
        head.setAttribute('aria-expanded', 'true');
        setTimeout(() => {
          body.style.removeProperty('display');
          body.style.removeProperty('max-height');
          body.style.removeProperty('height');
          body.style.overflow = 'visible';
        }, 500);
      }
    }

    function enableDesktopLogic () {
      if (desktopActive) return;
      desktopActive = true;

      ensureFirstOpen();

      accordions.forEach(acc => {
        const head = getHead(acc);
        if (!head) return;

        const clickHandler = function (e) {
          if (!DESKTOP()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          openAccordion(acc);
        };

        head._clickHandler = clickHandler;
        head.addEventListener('click', clickHandler, true);
      });

    }

    function disableDesktopLogic () {
      if (!desktopActive) return;
      desktopActive = false;

      accordions.forEach(acc => {
        const head = getHead(acc);
        if (!head) return;

        if (head._clickHandler) {
          head.removeEventListener('click', head._clickHandler, true);
          delete head._clickHandler;
        }
      });
    }

    /* ===== RESIZE MODE MANAGEMENT ===== */
    function updateMode () {
      if (DESKTOP()) {
        enableDesktopLogic();
        ensureFirstOpen();
      } else {
        disableDesktopLogic();
      }
    }

    openActiveLinkParents();
    ensureFirstOpen();
    updateMode();
    window.addEventListener('resize', updateMode);

  });

})();
